module.exports = __webpack_public_path__ + "img/感叹号.png";